import * as React from 'react'
import { useAuthContext } from 'providers/AuthProvider'
import SuccessPage from 'views/SuccessPage'

interface RecoverySuccessProps {
}

const RecoverySuccess: React.FunctionComponent<RecoverySuccessProps> = () => {
  const { signinRedirect } = useAuthContext()

  const title = 'Actualizamos tu usuario y contraseña con éxito'
  const pretitle = '¡Listo!'
  const subtitle = 'Presioná el siguiente botón y empezá a interbankear a full.'

  return (
    <SuccessPage title={title} subtitle={subtitle} action={signinRedirect} pretitle={pretitle} />
  )
}

export default RecoverySuccess
